export const auth = {
  authorLogin: "Author Login",
  authorSignUp: "Author Sign Up",
  email: "Email",
  password: "Password",
  confirmPassword: "Confirm Password",
  login: {
    loggingIn: "Logging in...",
    login: "Login",
    forgotPassword: "Forgot Password?",
    chooseProject: "Choose your project",
    superAdminLogin: "OVERHEAR Admin Login",
    projectAdminLogin: "Project Admin Login"
  },
  validation: {
    emailRequired: "Email is required",
    emailInvalid: "Please enter a valid email address",
    passwordRequired: "Password is required",
    passwordTooShort: "Password must be at least 6 characters long",
    confirmPasswordRequired: "Please confirm your password",
    passwordsDoNotMatch: "Passwords do not match"
  }
}
